import { AfterViewInit, Component, Inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { IS_SAAS, setTabsManualActivation } from "@coso/utility";

@Component({
  standalone:false,
  templateUrl: "./global-settings.component.html"
})
export class GlobalSettingsComponent implements AfterViewInit {
  constructor(@Inject(IS_SAAS) public isSaaS: boolean,private route: ActivatedRoute) {}

  ngAfterViewInit(): void {
    /** This will make tabs to be compliant with WAI ARIA practices */
    setTabsManualActivation();
    /** This will set the current route tab selected. */
    this.route.firstChild.url.subscribe((segments) => {
      const segment = segments[0].path;
      const tab = document.querySelector(`[id="tab-${segment}"]`);

      // Remove tabindex attribute
      tab.removeAttribute("tabindex");

      // Set the tab as selected
      tab.setAttribute("aria-selected", "true");
    });
  }
}
